import { AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'oc-levels',
  standalone: true,
  imports: [CommonModule],
  template: `<div class="oc-levels">
    <canvas #levelsCanvas width="500" height="20"></canvas>
  </div>`,
  styles: `
    :host {
      display: block;
      line-height: 0;
      padding-inline: 1px;
    }

    .ov-levels {
      overflow-x: hidden;
      height: 20px
    }
  `,
})
export class LevelsComponent implements AfterViewInit, OnChanges {
  @Input() levels: number[] = [];
  @Input() progress = 0;

  @ViewChild('levelsCanvas')
  canvasElement: ElementRef<HTMLCanvasElement>;

  get canvas() {
    return this.canvasElement.nativeElement;
  }

  context: CanvasRenderingContext2D | null;

  ngAfterViewInit(): void {
    this.context = this.canvas.getContext('2d');
    this.redraw();
  }

  ngOnChanges(changes: any) {
    if (changes.progress) {
      this.redraw();
    }
  }

  redraw() {
    if (!this.context) {
      return;
    }
    const ctx = this.context;
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.levels.forEach((level, index) => {
      const adjustedLevel = level / Math.max(...this.levels);
      ctx.fillStyle = index < this.progress - 1 ? '#462664' : '#dddddd';
      ctx.fillRect(index * 4, 20 - adjustedLevel * 20, 3, adjustedLevel * 20);
    });
  }
}
